module.exports = __webpack_public_path__ + "img/9.2da5be8c.png";